// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> axia-residential-arc-living-preferred -> the-pavilion
// Generated: 2026-10-01T17:22:54.960Z
// Counts: 5 design, 81 content, 25 slot group, 5 collection binding, 9 section, 4 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "VALUE",
    "value": "#00306b",
    "mappedField": null
  },
  "design._site.color.linkHover": {
    "cssVariable": "--vibe-color-link-hover",
    "overrideType": "VALUE",
    "value": "#00306b",
    "mappedField": null
  },
  "design._site.color.linkVisited": {
    "cssVariable": "--vibe-color-link-visited",
    "overrideType": "VALUE",
    "value": "#00306b",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Home Isn’t Just Where You Live, It’s Where Life Happens.</h2><p></p><h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1><p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Pavilion in Hanceville, AL, find your ideal home with spacious <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one, two, and three-bedroom floor plans</a>. Enjoy vibrant community life surrounded by cultural gems like the Evelyn Burrow Museum and Wallace State Community College, alongside outdoor retreats at CW Day Park and Veterans Memorial Park. Unlock the best of local living!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Hanceville, step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome Home to<br>The Pavilion</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.heading": {
    "overrideType": "VALUE",
    "customValue": " ",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.intro": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-map.config_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_repli_id"
  },
  "applynowactions.show_application_block": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "callrail-tracking.account_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_account_hash"
  },
  "callrail-tracking.company_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_company_id"
  },
  "contactus.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height_mobile": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.height": {
    "overrideType": "VALUE",
    "customValue": "2000",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "preferredemployerprogram.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Exclusive Apartment Offers for Employees in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.source": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.scheduler_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "scheduleatour.show_tour_scheduler": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.height": {
    "overrideType": "VALUE",
    "customValue": "1400",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019df43b-e550-7781-824c-e7c33d128c02.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Pavilion in Hanceville, AL, where spacious <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one, two, and three-bedroom floor plans</a> meet exceptional amenities. Just a block from campus, enjoy our lush landscaping, <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/pet-policy\">pet park</a>, and inviting grilling areas. Experience a maintenance-free lifestyle with professional management, modern kitchens, and ample closet space. Your perfect home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Please select your desired layout below.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Pavilion in Hanceville, AL, picture yourself in spacious, stylish apartments just a block from campus. Enjoy modern amenities like a <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/pet-policy\">pet park</a>, a grilling area, and professional management. With <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">floor plans</a> from one to three bedrooms, your maintenance-free lifestyle awaits amidst lush landscaping and thoughtful designs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience vibrant living at The Pavilion in Hanceville, AL, where convenience meets community. With spacious one, two, and three-bedroom floor plans, you'll feel right at home. Enjoy nearby attractions like <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.wallacestate.edu/\">Wallace State Community College</a>, the <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.burrowmuseum.org/\">Evelyn Burrow Museum</a>, and serene parks, creating a perfect blend of relaxation and recreation.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Cats and dogs allowed. Maximum 2 pets per unit. Monthly pet rent: $35 per cat or dog.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p>Cats and dogs allowed. Maximum 2 pets per unit.<br>Breed restrictions apply. Please contact the leasing office for additional details regarding restricted breeds and pet policies.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.stat_monthly_rent_value": {
    "overrideType": "VALUE",
    "customValue": "35",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<p>Dogs &amp; Cats Welcome</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Life feels a little easier at The Pavilion. Whether you're attending classes at Wallace State, commuting to work, raising a family, or simply looking for a peaceful place to call home, you'll find comfort, convenience, and a welcoming community waiting for you.</p><p>Our spacious one, two, and three-bedroom apartment homes are thoughtfully designed for the way you live today, offering comfortable layouts, inviting interiors, and the everyday features that help you feel at home from the moment you arrive.</p><p>Perfectly located in Hanceville, The Pavilion places you just minutes from Wallace State Community College, local shopping, dining, parks, and daily conveniences, giving you easy access to everything you need while offering the quiet charm of a community you'll love coming home to.</p><p>Spend time outdoors at the pet park with your four-legged companion, enjoy afternoons in the beautifully maintained picnic and grilling areas, or simply relax knowing our professional onsite team is dedicated to creating a community residents are proud to call home. At The Pavilion, you'll discover more than an apartment—you'll find a place where neighbors feel welcome, the grounds are thoughtfully cared for, and exceptional service is always a priority.</p><p>Inside your home, you'll appreciate stylish hard surface flooring, spacious closets, and functional layouts designed to make everyday living effortless. Select apartment homes also feature sleek black appliances, double closets, ceiling fans, washer and dryer connections, and well-equipped kitchens that blend comfort with convenience.</p><p>Additional community conveniences, including onsite laundry facilities, surface parking, and professional onsite management, help make daily life simple so you can spend more time enjoying what matters most.</p><p>Whether you're beginning your next semester, starting a new career, growing your household, or simply searching for a place that feels like home, The Pavilion offers the comfort, convenience, and friendly atmosphere you've been looking for.</p><p>Come experience why so many love calling The Pavilion home. Schedule your tour today and discover a community where comfort, care, and everyday living come together.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Pavilion in Hanceville, AL, our thoughtfully designed <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one, two, and three-bedroom apartments</a> invite you to experience modern living with a community touch. Step inside from the comfort of home with our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/virtual-tour\">virtual tour</a>, showcasing stunning spaces and amenities that await you! Don’t miss your chance to envision your new lifestyle!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_online_leasing_url"
      }
    }
  },
  "_template:hyperlocal::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "featuring/apartment-with-pool-monroe-30655::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d7970-0eb0-7733-93c5-9bb74f383089.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Wooden gazebo with picnic tables and benches in a courtyard setting."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d7970-1105-775a-8eba-735da0ff3a61.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Wooden gazebo with picnic tables and a brick building with a black door."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d5500-318e-76dc-a5d4-99fbd6a211d6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a sofa, armchair, coffee table, and TV."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[32].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[32].poi_featured_image_media.alt_text"
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d7970-15f4-71cc-b1c4-1f56fadf3b32.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with gray cabinets, black appliances, and granite countertops."
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54ff-b676-7138-848e-4c2a22493e3c.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d7970-15f4-71cc-b1c4-1f56fadf3b32.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d5500-318e-76dc-a5d4-99fbd6a211d6.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019f0ce3-eaa1-706a-82c0-06fc939d12e0.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019f0ce3-e34e-7759-b4bf-fc256d0f2161.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of apartment buildings with parking lot and trees."
      }
    }
  },
  "hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore The Community"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/virtual-tour"
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[32].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[32].poi_featured_image_media.alt_text"
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[1].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[1].poi_featured_image_media.alt_text"
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[7].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[7].image_media.alt_text"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019fa599-6edd-7463-8e6d-81591c83ccb3.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A Bengal cat and Yorkshire Terrier playfully reach for a feathered toy indoors."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d5500-318e-76dc-a5d4-99fbd6a211d6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a sofa, armchair, coffee table, and TV."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": [
      "custom_3dad7ab4-1c70-4335-9ab1-e5cf3cb6e698",
      "custom_b9222dec-d10a-4861-977d-24a8fe58b85c",
      "custom_2c9d7963-9cbf-4718-afcb-c866d1e88d9d"
    ],
    "orderedIds": [
      "custom_dcadfbd8-4a4c-4c0b-b711-e3988421730d",
      "custom_75309d79-20b1-4447-bd68-fbede65a387e",
      "custom_df10310a-e159-481e-8eb4-22de86632530",
      "custom_57507355-b006-4463-8ff3-e510056001d5",
      "custom_0ca9f177-508c-48e1-8d3b-53f02b9db147",
      "custom_c21f9034-7263-435e-bd39-7a7a6f9effbd",
      "custom_f2fb917c-2f44-4d5f-9816-576d0fa21699",
      "custom_bd9510f7-6fe6-40a1-bd78-a04037131d5e",
      "custom_a441cad7-f592-4240-8fc8-c180abaa7d78",
      "custom_3dad7ab4-1c70-4335-9ab1-e5cf3cb6e698",
      "custom_b9222dec-d10a-4861-977d-24a8fe58b85c",
      "custom_2c9d7963-9cbf-4718-afcb-c866d1e88d9d",
      "custom_ebd26de3-0ec0-4ede-95e8-323ba5c53a95",
      "custom_9087d780-ed44-4e04-91f2-741a1f35026c",
      "custom_5847ea9c-b95b-4587-a928-a35e752d0be6",
      "custom_54f6aaea-b916-4d93-9f50-fdaca185386f",
      "custom_c5888195-2f61-4d17-8608-64cd0abf726a",
      "custom_1f074f52-c138-4cd6-83f6-82f47b86eb73",
      "custom_9db420c2-1246-429d-b53e-012df2f00145",
      "custom_87b30a4d-5a9d-4146-a65a-df7b536e0498"
    ],
    "hiddenIndices": [
      1,
      3,
      4
    ],
    "ordering": [
      0,
      7,
      5,
      6,
      8,
      10,
      9,
      11,
      2,
      1,
      3,
      4,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": [
      "custom_2c9d7963-9cbf-4718-afcb-c866d1e88d9d",
      "custom_b9222dec-d10a-4861-977d-24a8fe58b85c"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      4,
      3
    ],
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.apartment_amenities": {
    "limit": null,
    "hiddenIds": [
      "custom_ce7a59b5-4fd7-468c-b3ff-b148df86e0dd",
      "custom_e118bce1-d56d-4933-bd44-d348f2a6d7c7",
      "custom_23fc3814-2a01-4093-942f-791bededcfd4",
      "custom_35afa6a6-acf6-421f-aab4-735cb4eaa928",
      "custom_d84f16e5-b331-4d7a-9e06-c5a4acaacf50"
    ],
    "orderedIds": [
      "custom_eb8f4b50-fded-4c59-a8a0-9604ca992a38",
      "custom_575683a2-c0e1-44ce-a14c-06c606e7256e",
      "custom_5f3bb318-0b16-4c61-bd97-a829ec9dbc1f",
      "custom_ff201111-2815-4dcb-8e88-8d2d72bda948",
      "custom_35afa6a6-acf6-421f-aab4-735cb4eaa928",
      "custom_d84f16e5-b331-4d7a-9e06-c5a4acaacf50",
      "custom_ce7a59b5-4fd7-468c-b3ff-b148df86e0dd",
      "custom_23fc3814-2a01-4093-942f-791bededcfd4",
      "custom_e118bce1-d56d-4933-bd44-d348f2a6d7c7"
    ],
    "hiddenIndices": [
      5,
      8,
      7,
      3,
      4
    ],
    "ordering": [
      0,
      1,
      2,
      6,
      3,
      4,
      5,
      7,
      8
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "callrail-tracking",
      "blockId": "callrail-tracking",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 9,
      "gridSpanMobile": 12
    }
  ],
  "schedule-a-tour": [
    {
      "sectionId": "elise-schedule-tour-iframe",
      "blockId": "elise-schedule-tour-iframe",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.block:iframe-embed": {
    "properties": {
      "overflow": "hidden"
    }
  },
  "floorplanslist.subtitle": {
    "properties": {
      "--vibe-color-hyperlink": "#ff0000"
    }
  },
  "propertyoverview.description": {
    "properties": {
      "--vibe-color-hyperlink": "#00306b"
    }
  }
};
